import { render, staticRenderFns } from "./logispurchaselist.vue?vue&type=template&id=8ae2d0f4"
import script from "./logispurchaselist.vue?vue&type=script&lang=js"
export * from "./logispurchaselist.vue?vue&type=script&lang=js"
import style0 from "./logispurchaselist.vue?vue&type=style&index=0&id=8ae2d0f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports